import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';

import { RichEditorComponent } from './rich-editor.component';

@NgModule({
    declarations: [
        RichEditorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        EditorModule
    ],
    exports: [
        RichEditorComponent
    ]
})
export class RichEditorModule { }
